export default __webpack_public_path__ + "static/media/i170vp.d7de86a1.webp";